type TrackFn = (data: Record<string, unknown>) => void;

const elementTypes: Record<string, string> = {
	card: "Card",
	button: "Button",
};

window.addEventListener("load", async () => {
	const { trackPageView, trackEvent } = (await import(
		// @ts-ignore — no types available for CDN import
		"https://assets.finn.no/pkg/@finn-no/pulse-sdk/v0/client.esm.min.js"
	)) as { trackPageView: TrackFn; trackEvent: TrackFn };

	trackPageView({
		object: { type: "Page", name: "FINN for business" },
		vertical: { name: "business_center" },
	});

	document.querySelectorAll<HTMLElement>("[data-track]").forEach((el) => {
		el.addEventListener("click", () => {
			const [type, ...rest] = (el.dataset.track ?? "").split(":");
			const name = rest.join(":");

			trackEvent({
				type: "Click",
				object: { type: "UIElement", elementType: elementTypes[type] ?? type, name },
				vertical: { name: "business_center" },
			});
		});
	});
});
